document.addEventListener("DOMContentLoaded", function () {
  const subscriptionBlocks = document.querySelectorAll(
    ".shopify_subscriptions_fieldset"
  );

  subscriptionBlocks.forEach((block) => {
    const subscriptionGroup = block.querySelector(
      ".shopify_subscriptions_app_block_label:nth-child(2)"
    );
    const oneTimeOption = block.querySelector(
      ".shopify_subscriptions_app_block_label:nth-child(1)"
    );
    const dropdownList = subscriptionGroup?.querySelector(
      ".shopify_subscriptions_app_block_label_children"
    );
    const subRadios = dropdownList?.querySelectorAll(
      "input[type='radio'][data-radio-type='selling_plan']"
    );
    const subscriptionWrapper =
      block.querySelectorAll(".shopify_subscriptions_app_block_label")[1];

    if (!subscriptionGroup || !dropdownList || !subRadios?.length) return;

    /* --------------------------------------------------
       Helpers (IMPORTANT: always re-query radios)
    -------------------------------------------------- */
    function getOneTimeRadio() {
      return block.querySelector(
        "input[type='radio'][data-radio-type='one_time_purchase']"
      );
    }

    function getFirstSubRadio() {
      return block.querySelector(
        "input[type='radio'][data-radio-type='selling_plan']"
      );
    }

    /* --------------------------------------------------
       Create dropdown label
    -------------------------------------------------- */
    let labelBtn = subscriptionGroup.querySelector(".dropdown-label");
    if (!labelBtn) {
      labelBtn = document.createElement("div");
      labelBtn.className = "dropdown-label";
      subscriptionGroup.insertBefore(labelBtn, dropdownList);
    }

    const firstSubLabel = subRadios[0]
      ?.closest("label")
      ?.textContent?.trim();
    labelBtn.textContent = firstSubLabel || "Choose an option";

    /* --------------------------------------------------
       Static benefits list
    -------------------------------------------------- */
    let staticList = subscriptionGroup.querySelector(".custom-static-list");
    if (!staticList) {
      staticList = document.createElement("div");
      staticList.className = "custom-static-list";

      const items = [
        "Always save 10% on every order",
        "Automatically earn loyalty points",
        "Skip, pause, or cancel anytime",
        "Never unexpectedly run out",
      ];

      items.forEach((text) => {
        const item = document.createElement("div");
        item.className = "list-item";
        item.innerHTML = `
          <img src="https://cdn.shopify.com/s/files/1/0693/4927/7853/files/right_sign.svg?v=1762178340" alt="">
          <span>${text}</span>
        `;
        staticList.appendChild(item);
      });

      subscriptionGroup.insertBefore(staticList, dropdownList.nextSibling);
    }

    /* --------------------------------------------------
       Price updater
    -------------------------------------------------- */
    function updateVisiblePrice() {
      const prices = block.querySelectorAll(
        ".shopify_subscriptions_in_widget_price"
      );
      prices.forEach((p) =>
        p.classList.add("shopify_subscriptions_app_block--hidden")
      );

      const selectedSub = block.querySelector(
        "input[data-radio-type='selling_plan']:checked"
      );

      if (selectedSub) {
        const priceBox = subscriptionGroup.querySelector(
          ".shopify_subscriptions_in_widget_price.allocation_price"
        );
        const price = selectedSub.getAttribute("data-variant-price");

        if (priceBox && price) {
          priceBox.innerHTML = price;
          priceBox.classList.remove(
            "shopify_subscriptions_app_block--hidden"
          );
        }
        return;
      }

      const oneTimeRadio = getOneTimeRadio();
      if (oneTimeRadio?.checked) {
        const price = oneTimeOption?.querySelector(
          ".shopify_subscriptions_in_widget_price"
        );
        price?.classList.remove(
          "shopify_subscriptions_app_block--hidden"
        );
      }
    }

    /* --------------------------------------------------
       Dropdown toggle
    -------------------------------------------------- */
    labelBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      const open = dropdownList.classList.toggle("open");
      dropdownList.style.display = open ? "block" : "none";
    });

    document.addEventListener("click", (e) => {
      if (!subscriptionGroup.contains(e.target)) {
        dropdownList.classList.remove("open");
        dropdownList.style.display = "none";
      }
    });

    /* --------------------------------------------------
       Subscription radio change
    -------------------------------------------------- */
    subRadios.forEach((radio) => {
      radio.addEventListener("change", () => {
        const label = radio.closest("label");
        labelBtn.textContent = label ? label.textContent.trim() : "";

        const oneTimeRadio = getOneTimeRadio();
        if (oneTimeRadio) oneTimeRadio.checked = false;

        subscriptionGroup.classList.add("selected");
        oneTimeOption?.classList.remove("selected");

        updateVisiblePrice();
        dropdownList.classList.remove("open");
        dropdownList.style.display = "none";
      });
    });

    /* --------------------------------------------------
       Subscription wrapper click
    -------------------------------------------------- */
    subscriptionWrapper?.addEventListener("click", () => {
      const firstSub = getFirstSubRadio();
      const anyChecked = block.querySelector(
        "input[data-radio-type='selling_plan']:checked"
      );

      if (firstSub && !anyChecked) {
        firstSub.checked = true;
        firstSub.dispatchEvent(
          new Event("change", { bubbles: true })
        );
      }

      const oneTimeRadio = getOneTimeRadio();
      if (oneTimeRadio) oneTimeRadio.checked = false;

      subscriptionGroup.classList.add("selected");
      oneTimeOption?.classList.remove("selected");

      updateVisiblePrice();
    });

    /* --------------------------------------------------
       One-time purchase
    -------------------------------------------------- */
    block.addEventListener("change", (e) => {
      if (
        e.target.matches(
          "input[data-radio-type='one_time_purchase']"
        )
      ) {
        subRadios.forEach((r) => (r.checked = false));

        oneTimeOption?.classList.add("selected");
        subscriptionGroup.classList.remove("selected");

        dropdownList.classList.remove("open");
        dropdownList.style.display = "none";

        updateVisiblePrice();
      }
    });

    /* --------------------------------------------------
       Init state
    -------------------------------------------------- */
    subRadios.forEach((r) => (r.checked = false));

    const oneTimeRadio = getOneTimeRadio();
    if (oneTimeRadio) {
      oneTimeRadio.checked = true;
      oneTimeOption?.classList.add("selected");
      subscriptionGroup.classList.remove("selected");
    }

    updateVisiblePrice();
    dropdownList.style.display = "none";
    dropdownList.classList.remove("open");
  });
});
